module.exports = __webpack_public_path__ + "img/arts.0b1323ba.jpg";